import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { customFormatters } from './customFormatters';
import lazyi18nextBackend from './lazyI18nextBackend';
/**
 * This is the default i18next config used by frontend projects
 */
export default function i18n(_a, debug) {
    var _b;
    var locale = _a.locale, resources = _a.resources;
    return i18next
        .use(initReactI18next)
        .use(lazyi18nextBackend())
        .use(customFormatters)
        .init({
        partialBundledLanguages: true,
        keySeparator: '$',
        lng: locale,
        fallbackLng: 'en',
        debug: debug,
        interpolation: {
            escapeValue: false,
        },
        resources: (_b = {},
            _b[locale] = {
                translation: resources,
            },
            _b),
    }, undefined);
}
//# sourceMappingURL=presetI18nClientConfig.js.map